import Vue from 'vue'
import Router from 'vue-router'
import { NativeInterface } from './plugins/NativeInterface'
import Loading from '@/views/Loading'
import Landing from '@/views/Landing'
import Donate from '@/views/Donate'
import Ranking from '@/views/Ranking'
import GroupList from '@/views/GroupList'
import Overview from '@/views/Overview'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      meta: {
        title: '你学英语我捐课'
      },
      component: Loading
    },
    {
      path: '/landing',
      name: 'landing',
      meta: {
        title: '你学英语我捐课'
      },
      component: Landing
    },
    {
      path: '/donate',
      name: 'donate',
      meta: {
        title: '你学英语我捐课'
      },
      component: Donate
    },
    {
      path: '/ranking',
      name: 'ranking',
      meta: {
        title: '爱心排行榜'
      },
      component: Ranking
    },
    {
      path: '/groups',
      name: 'groups',
      meta: {
        title: '高校战队'
      },
      component: GroupList
    },
    {
      path: '/overview',
      name: 'overview',
      meta: {
        title: '我的爱心地图'
      },
      component: Overview
    }
  ]
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面 title */
  if (to.meta.title) {
    document.title = to.meta.title
    NativeInterface.invoke('configNavBar', function () {}, JSON.stringify({
      title: to.meta.title,
      hasShareBtn: false,
      hasCloseBtn: false
    }))
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router.js